const AppColors = {
  mainBlue: '#0091FA',
  mainBlack: '#1E1E1E',
  mobileBlack: '#171717',
  activeGray: '#4D4D4D',
  activeGray75: '#4D4D4DBF',
  semiWhite: '#FFFFFF80',
  semiBlack: '#00000080',
  liveGreen: '#05D01A',
  archiveRed: '#FF0000',
  archiveGray: '#B7B7B7',
  containerGray: '#262626',
  containerGray75: '#262626BF',
};

export default AppColors;
